import AppRouter from './Router';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
// import ToastContainer from './CommonComponents/Toster';
import React, { useRef, useState } from 'react';
import Header from './Components/Header';
import Footer from './Components/Footer';
import { WizardProvider } from './Contexts/WizardContext';
import { APIProvider } from "@vis.gl/react-google-maps";
import { StripeProvider } from './Components/StripeProvider';

const googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

function App() {
  const [notifications, setNotifications] = useState([]);

  return (
    <StripeProvider>
      <Router>
        <APIProvider
              apiKey={googleApiKey}
              region="US"
              language="en"
              libraries={["places"]}
        >
          <WizardProvider>
            <div className="App relative">
              <div
                className="absolute inset-0 opacity-10 bg-cover bg-center pointer-events-none -z-10"
                style={{
                  backgroundImage: `url('https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1920')`,
                }}>
              </div>
              <div className="flex flex-col min-h-screen">
                <Header/>
                <div className='flex flex-1'>
                  <AppRouter />
                </div>
                <Footer/>
              </div>
            </div>
          </WizardProvider>
        </APIProvider>
    </Router>
  </StripeProvider>
  );
}

export default App;